// the file shared_errors.go should be kept in sync with this file and vice versa
export const SharedErrorDuplicateOrgName = 101;
export const SharedErrorDuplicateSlug = 102;
export const SharedErrorSalesforceAccountAlreadyExists = 103;
export const SharedErrorItemAlreadyExists = 104;
export const SharedErrorDocumentationPermissionFailure = 105;
